<!-- <nav mat-tab-nav-bar [tabPanel]="tabPanel">
  @for (link of links; track link) {
    <a mat-tab-link
      (click)="activeLink = link"
      [active]="activeLink == link"> {{link}} </a>
  }
  <a mat-tab-link disabled>Disabled Link</a>
</nav>
<mat-tab-nav-panel #tabPanel>
  <div class="example-content">
    <h1>Selected: {{activeLink}}</h1>
    <p>Click on a link to change the active link.</p>
  </div>
</mat-tab-nav-panel>
{{ selectedWeek}}
<app-menu [week]="getWeekSelectedWeek()" [hollydays]="hollydays" (haveChanges)="menuHaveChanges($event)"></app-menu>

<button matButton="elevated" class="example-action-button" (click)="addLink()">
  Add link
</button> -->




<mat-tab-group (selectedIndexChange)="selectedWeekChanged($event)" [selectedIndex]="getSelectedTab()" class="tab-group"
  mat-align-tabs="start" backgroundColor="theme" class="navbar1" animationDuration="0ms">

  <!-- <mat-tab label="Archive" id="archive" [disabled]="menuHaveUnsavedChanges">
    <ng-template matTabContent>
      <div style="text-align: center; margin-top: 20px;">
        <h3>Archive</h3>
      </div>
    </ng-template>
  </mat-tab> -->

  @for (item of weeks; track item) {
  <mat-tab [label]="item.tabLabel" [id]="item" [disabled]="menuHaveUnsavedChanges">
    
    <ng-template mat-tab-label>
      <div>
        @if (isLocked(item.week) && item.isCurrentWeek){
          <span class="tab tab-current"><mat-icon>lock</mat-icon>{{item.tabLabel}}</span>
          } 
        @else if (item.isCurrentWeek){
          <span class="tab tab-current"> {{item.tabLabel}}</span>
          } 
        @else if (item.isBefore && isLocked(item.week)){
        <span class="tab tab-before"><mat-icon>lock</mat-icon>{{item.tabLabel}}</span>
        } 
        @else if (item.isBefore){
        <span class="tab tab-before">{{item.tabLabel}}</span>
        } 
        @else if (isLocked(item.week)){
        <span class="tab tab-locked"><mat-icon>lock</mat-icon>{{item.tabLabel}}</span>
        } 
        @else {
        <span class="tab">{{item.tabLabel}}</span>
        }
      </div>
    </ng-template>
    <ng-template matTabContent>
      <app-menu></app-menu>
    </ng-template>
  </mat-tab>
  }


</mat-tab-group>

<button mat-raised-button color="primary" class="archive-button" (click)="arciveClicked($event)" [disabled]="menuHaveUnsavedChanges" style="margin: 20px">
  <mat-icon>archive</mat-icon>
  Load more weeks
</button>